@if (licenseStatus() === LicenseStatus.Unknown) {
  <div class="portal-loading-overlay" aria-busy="true" aria-label="Loading">
    <div class="portal-loading-spinner"></div>
  </div>
}

@if (licenseStatus() === LicenseStatus.NotFound || licenseStatus() === LicenseStatus.StoreDisabled) {
  <div
    class="donations-disabled-overlay"
    role="alertdialog"
    aria-modal="true"
    [attr.aria-labelledby]="licenseStatus() === LicenseStatus.NotFound ? 'nl-title' : 'dd-title'"
    [attr.aria-describedby]="licenseStatus() === LicenseStatus.NotFound ? 'nl-desc' : 'dd-desc'"
  >
    <div class="donations-disabled-dialog">
      <div class="donations-disabled-icon">
        <app-icon name="alert-circle" [size]="40" />
      </div>

      @if (licenseStatus() === LicenseStatus.NotFound) {
        <h2 class="donations-disabled-title" id="nl-title">No License Found</h2>
        <p class="donations-disabled-message" id="nl-desc">
          No license found for this user. Please contact your administrator for assistance.
        </p>
      } @else {
        <h2 class="donations-disabled-title" id="dd-title">Store Not Accepting Donations</h2>
        <p class="donations-disabled-message" id="dd-desc">
          Your store is currently not accepting donations. Please contact your administrator for assistance.
        </p>
      }

      <button mat-raised-button color="primary" (click)="onRetry()">OK</button>
    </div>
  </div>
}

<router-outlet />
